import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const InfoMessageContainer = styled('div')(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.space._300,
    padding: theme.space._300,
    borderRadius: theme.space._100,
    width: "100%"
}));

export const InfoMessageTypography = styled(Typography)(({ theme }) => ({
    fontFamily: theme.fonts.default,
    fontStyle: "normal",
    fontWeight: theme.fontWeights.medium,
    lineHeight: theme.lineHeights.base,
}));

